import React, { useState, useEffect, useRef } from 'react';
import ImageDisplayTarget from './ImageRating/ImageDisplayTarget';
import TaskControls from './ImageRating/TaskControls';
import useTaskData from './ImageRating/useTaskData';
import { useSetTaskAndIteration } from '../hooks/useSetTaskAndIteration';
import { textTaskStatementTarget, textTaskStatementFree } from '../locales/en';
import { useFooter } from './FooterContext';
import IterateController from './ImageRating/IterateController';

import {
    createTask,
    saveTaskDuration,
    deleteAllTasks
} from './ImageRating/api';


export default function ImageRatingComponent({ uuid, timer, debugging, tutorial }) {
    const setTaskAndIteration = useSetTaskAndIteration();
    const { showMessage } = useFooter();
    const {
        taskId,
        setTaskId,
        resetAllTaskData
    } = useTaskData();

    const [showInitialImage, setShowInitialImage] = useState(true);

    /** 
     * Handles changes to the "satisfied" state for the task.
     *
     * This function is called when the user clicks the
     * "I'm satisfied" button or cancels the satisfaction dialog.
     * @async
     * @param {boolean} satisfied - Whether the user is satisfied with the current design.
     *   - `true` → user has confirmed satisfaction and the dialog should close.
     *   - `false` → user canceled or wants to continue iterating.
     * @returns {Promise<void>} Resolves when the satisfaction change is fully processed.
     */
    const handleSatisfyChange = async (satisfied) => {
        if (!satisfied) {
            return;
        }

        // try {
        const data = await createTask(uuid);
        const newTaskId = data.taskId;

        setTaskId(newTaskId);
        localStorage.setItem('currentTaskId', newTaskId.toString());
        // setTaskDataInitialized(true);

        setTaskAndIteration(newTaskId, 0);

        showMessage("New task Created", `Task ${newTaskId} was successfully created. The iteration starts again at 0.`, "info");

    };


    const resetTaskId = async () => {
        if (window.confirm("Do you really want to delete all task data? This process cannot be undone.")) {
            try {
                console.log('Starting reset process...');

                // Reset frontend state first
                resetAllTaskData();
                console.log('Frontend state reset complete');

                // Delete backend data (add await)
                console.log('Calling deleteAllTasks...');
                const deleteResult = await deleteAllTasks();
                console.log('deleteAllTasks result:', deleteResult);

                // Create new task
                console.log('Creating new task...');
                const taskData = await createTask(uuid);
                console.log('New task created:', taskData);

                // Set new task ID
                setTaskId(taskData.taskId);
                localStorage.setItem('currentTaskId', taskData.taskId.toString());
                setTaskAndIteration(taskData.taskId, 0);

                showMessage("Confirmation", `New task with ID ${taskData.taskId} has been created.`, "info");

                if (timer && typeof timer.start === 'function') {
                    timer.start();
                    console.log(`Timer started for new Task ${taskData.taskId}`);
                }
            } catch (error) {
                console.error('Error resetting tasks:', error);
                showMessage("Error", "Failed to reset tasks: " + error.message, "error");
            }
        }
    };
    
    return (
        <div className='main'>

            {debugging &&
                <TaskControls
                    uuid={uuid}
                    taskId={taskId}
                    onResetTasks={resetTaskId}
                    onToggleInitialImage={() => setShowInitialImage(prev => !prev)}
                    showInitialImage={showInitialImage}
                    debugging={debugging}
                />
            }
            <div className='rowFlex'>

                <ImageDisplayTarget
                    uuid={uuid}
                    taskId={taskId}
                />

                <IterateController uuid={uuid}
                    taskId={taskId}
                    timer={timer}
                    tutorial={tutorial}
                    saveTaskDuration={saveTaskDuration}
                    onSatisfyChange={handleSatisfyChange}
                    textTaskStatement={taskId === "13" || taskId === 13 ? textTaskStatementFree : textTaskStatementTarget} />
            </div>
        </div>
    );
}